<template>
  <div>
    <header-card
      :title="$t('reply.enable-new')"
      show-back
      :route-url="{name:'owner:reports'}"
    />
    <process-reply />
  </div>
</template>

<script>
import ProcessReply from '@/views/owner-fb/reply/components/ProcessReply'
import HeaderCard from '@/@bya3/components/cards/HeaderCard'

export default {
  name: 'AddReply',
  components: { HeaderCard, ProcessReply },
}
</script>
